import React from 'react';
import { FaImage, FaEdit, FaTrash } from 'react-icons/fa';

const TemplateCard = ({ template, onSelect, onEdit, onDelete }) => {
    const { name, description, platform, type, dimensions } = template;

    return (
        <div className="bg-white rounded-lg shadow-md p-4 hover:shadow-lg transition-shadow">
            <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-semibold text-gray-800">{name}</h3>
                <div className="flex space-x-2">
                    {onEdit && (
                        <button
                            onClick={() => onEdit(template)}
                            className="text-blue-500 hover:text-blue-600"
                            title="Editar plantilla"
                        >
                            <FaEdit />
                        </button>
                    )}
                    {onDelete && (
                        <button
                            onClick={() => onDelete(template)}
                            className="text-red-500 hover:text-red-600"
                            title="Eliminar plantilla"
                        >
                            <FaTrash />
                        </button>
                    )}
                </div>
            </div>

            <div className="mb-4">
                <p className="text-gray-600 text-sm">{description}</p>
            </div>

            <div className="flex items-center justify-between text-sm text-gray-500">
                <div className="flex items-center">
                    <FaImage className="mr-2" />
                    <span>{dimensions.width}x{dimensions.height}</span>
                </div>
                <div className="flex space-x-2">
                    <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded">
                        {platform}
                    </span>
                    <span className="bg-green-100 text-green-800 px-2 py-1 rounded">
                        {type}
                    </span>
                </div>
            </div>

            {onSelect && (
                <button
                    onClick={() => onSelect(template)}
                    className="mt-4 w-full bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600 transition-colors"
                >
                    Usar Plantilla
                </button>
            )}
        </div>
    );
};

export default TemplateCard; 